import { render, staticRenderFns } from "./TypesCheckbox.vue?vue&type=template&id=b8f5ae74&scoped=true&"
import script from "./TypesCheckbox.vue?vue&type=script&lang=js&"
export * from "./TypesCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./TypesCheckbox.vue?vue&type=style&index=0&id=b8f5ae74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8f5ae74",
  null
  
)

export default component.exports